import axios from 'axios';
import globalVars from '../globalVars.js';

export function requestJpmNotification({ subDept, txnId, createdAt }) {
	return axios.post(`${globalVars.PaymentGateway}/payments/getAndSaveJPMInfo` +
		`?subDept=${subDept}` +
		`&txnId=${txnId}` +
		`&createdAt=${encodeURIComponent(createdAt)}`);
}
